module.exports = __webpack_public_path__ + "src/img/bangong.508e5f1b.svg";